import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MaterialModule } from "./material.module";
import { FeatherIconsModule } from "./components/feather-icons/feather-icons.module";
import { NgxMaskModule } from "ngx-mask";
import { NgBusyModule } from "ng-busy";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { MoneyFormatPipe } from "../core/pipes/money-format.pipe";

// import { PaginationModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { SearchPatientComponent } from "./components/search-patient/search-patient.component";
import { MainListeAccueilByEtapeComponent } from "./components/main-liste-accueil-by-etape/main-liste-accueil-by-etape.component";
import { AddDocumentComponent } from "./components/add-document/add-document.component";
// import { SearchMedicamentComponent } from "./components/search-medicament/search-medicament.component";
// import { CKEditorModule } from "ng2-ckeditor";
import { MatTabsModule } from "@angular/material/tabs";
import { FindMedocComponent } from "./components/find-medoc/find-medoc.component";
import { DetailsDocumentsJointsComponent } from "./components/details-documents-joints/details-documents-joints.component";
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgSelectModule } from "@ng-select/ng-select";
import { FormPreviewPdfComponent } from "./components/form-preview-pdf/form-preview-pdf.component";
import { HistoriqueCircuitTraitementComponent } from "./components/historique-circuit-traitement/historique-circuit-traitement.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { FormPrevPdfHistoResultatComponent } from "./components/form-prev-pdf-histo-resultat/form-prev-pdf-histo-resultat.component";
import { DetailVisiteMedecinComponent } from "./components/detail-visite-medecin/detail-visite-medecin.component";
import { ElementByPagePaginatorComponent } from "./components/element-by-page-paginator/element-by-page-paginator.component";
import { TimePickerComponent } from "./components/time-picker/time-picker.component";
import { MainListeAccueilDialyseByEtapeComponent } from "./components/main-liste-accueil-dialyse-by-etape/main-liste-accueil-dialyse-by-etape.component";
import { FullCalendarModule } from "@fullcalendar/angular";
import { PopoverModule } from "ngx-bootstrap/popover";
import { PosologiePrescriptionComponent } from "./components/posologie-prescription/posologie-prescription.component";
import { TimeLineComponent } from "./components/time-line/time-line.component";
import { PriseDeDecisionWorkflowComponent } from "./components/prise-de-decision-workflow/prise-de-decision-workflow.component";
import { AppAccessDirective } from "./directive/app-access.directive";
// import { CKEditorModule } from 'ng2-ckeditor';
import { ChartModule } from 'angular-highcharts';
import { SearchMdicamentProComponent } from "./components/search-mdicament-pro/search-mdicament-pro.component";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { LockScreenModalComponent } from "../core/service/lock-screen-modal/lock-screen-modal.component";
import { DateFormatPipe } from "../core/pipes/date-format.pipe";
import { DateTimeFormatPipe } from "../core/pipes/date-time-format.pipe";

import { SafePipe } from "../core/pipes/safe.pipe";
import { AgeRangeMaskDirective } from './directive/age-range-mask.directive';
import { DynamicComponentDirective } from './directive/dynamic-component.directive';
import { UploadExcelBeneficiaireComponent } from "./components/upload-excel-beneficiaire/upload-excel-beneficiaire.component";
import { ListBeneficiaireToCheckComponent } from "./components/list-beneficiaire-to-check/list-beneficiaire-to-check.component";
import { SearchPrestataireComponent } from "./components/search-prestataire/search-prestataire.component";
import { RoundDecimalPipe } from "../core/pipes/round-decimal.pipe";
import { FormEtapeValidationComponent } from "../layout/header/form-etape-validation/form-etape-validation.component";
import { FormHistoValidationComponent } from "../layout/header/form-histo-validation/form-histo-validation.component";
import { FormDecisionComponent } from "../layout/header/form-decision/form-decision.component";
import { FormItemsValidateComponent } from "../layout/header/form-items-validate/form-items-validate.component";
import { FormViewNotifContentComponent } from "../layout/header/form-view-notif-content/form-view-notif-content.component";
import { ScrollSearchPrestataireComponent } from "./components/scroll-search-prestataire/scroll-search-prestataire.component";
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from "@angular/material/divider";
import { AbsolutePipe } from "../core/pipes/absolute.pipe";
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { IntegerFormatPipe } from "../core/pipes/integer-format.pipe";
import { MatSelectModule } from "@angular/material/select";
import { ScrollSearchActeComponent } from "./components/scroll-search-acte/scroll-search-acte.component";
import { ScrollSearchBeneficiaireComponent } from "./components/scroll-search-beneficiaire/scroll-search-beneficiaire.component";
import { ScrollSearchMedocComponent } from "./components/scroll-search-medoc/scroll-search-medoc.component";
import { ScrollSearchPoliceComponent } from "./components/scroll-search-police/scroll-search-police.component";
import { ScrollSearchCollegeComponent } from "./components/scroll-search-college/scroll-search-college.component";
import { ScrollSearchGarantComponent } from "./components/scroll-search-garant/scroll-search-garant.component";
import { ScrollSearchSouscripteurComponent } from "./components/scroll-search-souscripteur/scroll-search-souscripteur.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { TruncatePipe } from "../core/pipes/truncate.pipe";
import { ScrollSearchAffectionComponent } from "./components/scroll-search-affection/scroll-search-affection.component";
import { ThousandSeparatorDirective } from "./directives/thousand-separator.directive";
import { PrescriptionActeChatDialogComponent } from "./components/prescription-acte-chat-dialog/prescription-acte-chat-dialog.component";


@NgModule({
  declarations: [
    MoneyFormatPipe,
    TruncatePipe,
    IntegerFormatPipe,
    AbsolutePipe,
    SearchPatientComponent,
    MainListeAccueilByEtapeComponent,
    AddDocumentComponent,
    // SearchMedicamentComponent,
    FindMedocComponent,
    DetailsDocumentsJointsComponent,
    FormPreviewPdfComponent,
    FormPrevPdfHistoResultatComponent,
    HistoriqueCircuitTraitementComponent,
    DetailVisiteMedecinComponent,
    ElementByPagePaginatorComponent,
    TimePickerComponent,
    MainListeAccueilDialyseByEtapeComponent,
    PosologiePrescriptionComponent,
    TimeLineComponent,
    PriseDeDecisionWorkflowComponent,
    AppAccessDirective,
    SearchMdicamentProComponent,
    LockScreenModalComponent,
    DateFormatPipe,
    RoundDecimalPipe,
    SafePipe,
    DateTimeFormatPipe,
    AgeRangeMaskDirective,
    DynamicComponentDirective,
    UploadExcelBeneficiaireComponent,
    ListBeneficiaireToCheckComponent,
    SearchPrestataireComponent,
    FormEtapeValidationComponent,
    FormHistoValidationComponent,
    FormDecisionComponent,
    FormItemsValidateComponent,
    FormViewNotifContentComponent,
    ScrollSearchPrestataireComponent,
    ScrollSearchActeComponent,
    ScrollSearchBeneficiaireComponent,
    ScrollSearchMedocComponent,
    ScrollSearchPoliceComponent,
    ScrollSearchCollegeComponent,
    ScrollSearchGarantComponent,
    ScrollSearchSouscripteurComponent,
    ScrollSearchAffectionComponent,
    ThousandSeparatorDirective,
    PrescriptionActeChatDialogComponent,

  ],
  imports: [
    CommonModule,
    // CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxMaskModule.forRoot(),
    NgBusyModule,
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    MatTabsModule,
    NgSelectModule,
    FullCalendarModule,
    MatIconModule,
    MatButtonModule,
    // CKEditorModule,
    ChartModule,
    PopoverModule.forRoot(),
    UiSwitchModule.forRoot({
      size: 'small',
      color: 'red',
      switchColor: 'white',
      defaultBgColor: 'green',
      defaultBoColor: '#476EFF',
      checkedLabel: 'Inactif',
      uncheckedLabel: 'Actif',
      checkedTextColor: 'white',
      uncheckedTextColor: 'white'
    }),
    PerfectScrollbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    MatExpansionModule,
    MatBadgeModule,
    MatStepperModule,
    MatDialogModule,
    MatSelectModule,
    MatPaginatorModule


  ],
  exports: [
    CommonModule,
    // CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    FeatherIconsModule,
    NgBusyModule,
    PaginationModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    PopoverModule,
    // PaginationModule.forRoot(),
    // NgxMaskModule,
    MoneyFormatPipe,
    DateFormatPipe,
    RoundDecimalPipe,
    TruncatePipe,
    BsDatepickerModule,
    SearchPatientComponent,
    MainListeAccueilByEtapeComponent,
    AddDocumentComponent,
    // SearchMedicamentComponent,
    FindMedocComponent,
    DetailsDocumentsJointsComponent,
    FormPreviewPdfComponent,
    UiSwitchModule,
    NgSelectModule,
    FullCalendarModule,

    NgbModule,

    ElementByPagePaginatorComponent,
    TimePickerComponent,
    MainListeAccueilDialyseByEtapeComponent,
    PosologiePrescriptionComponent,
    TimeLineComponent,
    PriseDeDecisionWorkflowComponent,
    AppAccessDirective,
    ChartModule,
    SearchMdicamentProComponent,
    PerfectScrollbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    PerfectScrollbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    SafePipe,
    DateTimeFormatPipe,
    DynamicComponentDirective,
    UploadExcelBeneficiaireComponent,
    ListBeneficiaireToCheckComponent,
    SearchPrestataireComponent,
    FormEtapeValidationComponent,
    FormHistoValidationComponent,
    FormDecisionComponent,
    FormItemsValidateComponent,
    FormViewNotifContentComponent,
    ScrollSearchPrestataireComponent,
    ScrollSearchActeComponent,
    ScrollSearchBeneficiaireComponent,
    ScrollSearchMedocComponent,
    ScrollSearchPoliceComponent,
    ScrollSearchCollegeComponent,
    MatExpansionModule,
    MatBadgeModule,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    AbsolutePipe,
    MatStepperModule,
    MatDialogModule,
    IntegerFormatPipe,
    MatSelectModule,
    ScrollSearchGarantComponent,
    ScrollSearchSouscripteurComponent,
    MatPaginatorModule,
    ScrollSearchAffectionComponent,
    ThousandSeparatorDirective,
  ],
  entryComponents: [TimePickerComponent]
})
export class SharedModule { }
